import Icon from './Icons';
import Revelar from './Revelar';
import { site, linkWhatsApp } from '../config';
import './Atendimento.css';

const etapas = [
  {
    numero: '01',
    titulo: 'Contato inicial',
    texto:
      'Você relata o que aconteceu por telefone, WhatsApp ou presencialmente. Esse primeiro contato é sigiloso e não gera compromisso.',
  },
  {
    numero: '02',
    titulo: 'Análise do caso',
    texto:
      'Estudo do boletim de ocorrência, do inquérito ou do processo e dos documentos disponíveis, para dimensionar a situação com precisão.',
  },
  {
    numero: '03',
    titulo: 'Proposta e contrato',
    texto:
      'Apresentação por escrito do escopo do trabalho, das providências cabíveis e dos honorários — tudo definido antes de qualquer contratação.',
  },
  {
    numero: '04',
    titulo: 'Atuação e acompanhamento',
    texto:
      'Execução da defesa com atualização periódica sobre prazos, audiências e decisões, em linguagem que você entende.',
  },
];

const canais = [
  { icone: 'local', titulo: 'Presencial', texto: `Escritório em ${site.endereco.cidade}/${site.endereco.uf}, com hora marcada.` },
  { icone: 'digitais', titulo: 'On-line', texto: 'Reuniões por vídeo para clientes de todo o Brasil.' },
  { icone: 'urgencia', titulo: 'Urgência', texto: 'Deslocamento a delegacias e fóruns em casos de flagrante.' },
];

export default function Atendimento() {
  return (
    <section className="secao secao--escura" id="atendimento">
      <div className="container">
        <div className="cabecalho-secao">
          <span className="rotulo">Como funciona</span>
          <h2 className="titulo-secao">Do primeiro contato à decisão final</h2>
          <p className="subtitulo-secao">
            Um caminho claro, sem surpresas: você sabe desde o início o que será
            feito, quanto custa e em que ponto o processo está.
          </p>
        </div>

        <ol className="etapas">
          {etapas.map((etapa, indice) => (
            <Revelar as="li" key={etapa.numero} atraso={indice * 110} className="etapa">
              <span className="etapa__numero">{etapa.numero}</span>
              <h3>{etapa.titulo}</h3>
              <p>{etapa.texto}</p>
            </Revelar>
          ))}
        </ol>

        <div className="atendimento__rodape">
          <ul className="canais">
            {canais.map((canal) => (
              <li key={canal.titulo}>
                <Icon name={canal.icone} size={22} />
                <div>
                  <strong>{canal.titulo}</strong>
                  <span>{canal.texto}</span>
                </div>
              </li>
            ))}
          </ul>

          <a
            className="btn btn--ouro"
            href={linkWhatsApp('Olá, gostaria de agendar uma consulta com o *Dr. Felipe Almeida.*')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="whatsapp" size={18} />
            Agendar consulta
          </a>
        </div>
      </div>
    </section>
  );
}
